/***
 * 
 * 数据看板
 */
 import ajax from '@/utils/ajax'

  // 查询活动
export const getActiveList = params => ajax.post('/activity/activityListByType', params)

// 活动信息
export const getActiveDetail = params => ajax.post('/activity/activeInfo', params)

// 送水活动信息
export const getWaterActiveDetail = params => ajax.post('/market/deliverWaterDetailByActivityId', params)

// 活动按照更新时间排序
export const getActiveSort = params => ajax.post('/activity/activityByGasIdAndType', params)

// 查询数据更新时间
export const getUpdateTime = params => ajax.post('/activity/dataBoard/realCountTime', params)

 /****
  * 活动概览
  */

 // 查询活动概述
export const getOverview = params => ajax.post('/activity/dataBoard/overview', params)

// 查询更多活动指标
export const getAllTarget = params => ajax.post('/activity/dataBoard/moreTarget', params)

/******
 * 活动趋势
 */

// 活动指标枚举
export const trendTarget = params => ajax.post('/activity/dataBoard/trendTarget', params)

// 活动趋势图
export const getActiveTrend = params => ajax.post('/activity/dataBoard/trend', params)

// 活动效果
export const getActiveResult = params => ajax.post('/activity/dataBoard/getIncomeForSale', params)

// 用户贡献对比
export const getUserContribute = params => ajax.post('/activity/dataBoard/getUserContribution', params)

// 近30天同类活动对比
export const getSimilarActive = params => ajax.post('/activity/dataBoard/getSimilarActivityDetail', params)

// 营销数据导出
export const exportActivityData = params => ajax.post('activity/dataBoard/exportActivityData', params)

/*****  抽奖宝   ******/

// 活动数据
export const getActiveData = params => ajax.post('/activity/dataBoard/trendForDraw', params)

// 发送手机验证码
export const sendCode = params => ajax.post('/activity/sendVerificationCode', params)

// 查询收货地址
export const getAddress = params => ajax.post('/activity/getDrawAddress', params)

// 修改收货地址
export const changeAddress = params => ajax.post('/activity/updateDrawAddress', params)

// 获取签约协议链接
export const querySignContract = params => ajax.post('/activity/querySignContract', params)

// 签约
export const signApply = params => ajax.post('/activity/signApply', params)
